import type { IconProps } from '../types/IconProps.ts';
export const Angry: IconProps = {
    name: 'Angry',
    children: [
        `<path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20" />`,
        `<path d="M8 16c1.77-2.67 6.23-2.67 8 0M7 7l2 1M15 8l2-1" />`,
        `<circle cx="8" cy="11" r=".5" />`,
        `<circle cx="16" cy="11" r=".5" />`,
    ]
};